module.exports = __webpack_public_path__ + "img/jarvis-headshot.b5883cd0.jpg";